export default __webpack_public_path__ + "static/icon-logo-dis-51551e9b6bd491ec535009cd597ceaff.png";